import { defineStore } from "pinia";

export const useNotifications = defineStore("notifications", {
    namespaced: true,

    state: () => ({
        id: 0,
        notifications: [],
    }),

    actions: {

        success(message) {
            this.newNotication("green",5000,message,"mdi-check-circle")
        },

        error(message) {
            this.newNotication("red",10000,message,"mdi-alert-circle")
        },

        newNotication(color="",timeout=5000,message="Demo Alert",icon="mdi-floppy") {

            this.id = this.id+1

            let id = this.id

            let notifica = {
                color: color,
                timeout: timeout,
                message: message,
                icon: icon,
                id: this.id,
                close: () => {
                    for(let i=0;i<this.notifications.length;i++) {
                        if(id == this.notifications[i].id) {
                           this.notifications.splice(i,1)
                        }
                    }
                }

            }

            this.notifications.push(notifica)


            setTimeout(() => {

                for(let i=0;i<this.notifications.length;i++) {
                    if(id == this.notifications[i].id) {
                       this.notifications.splice(i,1)
                    }
                }
            },timeout)

            return notifica

        }
    },

    getters: {

    }
});